export default "__VITE_ASSET__b862de49__"